<template lang="html">
  <div class="commment-list">
    <loadData
      viewName="evaluateList"
      :fetchData="evaluatesList"
      :fetchMethod="getEvaluate"
      :controlPage="changePage"
      :page="page"
      :pageSize="size"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
    />
    <div v-show="isBottom" class="data-bottom"><span></span></div>
    <imagePreview :items="previewImages"></imagePreview>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import loadData from '@/components/loadMore'
import imagePreview from '@/components/common/viewImage'
import empty from '@/components/common/empty'

export default {
  data() {
    return {
      page: 1,
      size: 10,
      firstFetch: true,
      hasErr: false,
      uid: null,
      isBottom: false
    }
  },
  created() {
    this.uid = this.$route.params.uid
    this.getEvaluate()
    this.$$title('服务评论')
    this.$$loading(false)
    this.$$tracker('140101', '10000', '11022')
    this.$$share({
      desc: '这是孩子王的会员对我服务的评价，欢迎找我进行育儿服务哦！',
      title: '我的会员评价'
    })
  },
  methods: {
    async getEvaluate() {
      try {
        const extendStr = JSON.stringify({
          community: this.uid
        })
        const evaluatelist = await this.$store.dispatch('getEvaluatePage', {
          extend: extendStr,
          page: this.page,
          size: this.size,
          show_user: 1,
          show_reply: 1
        })
        if (evaluatelist.code === 1001) {
          this.hasErr = false
          if (this.page !== 1) {
            this.firstFetch = false
          }
          if (this.page === 1 && evaluatelist.data.count === 0) {
            this.firstFetch = false
          }
          if (
            this.page !== 1 &&
            evaluatelist.data.count < this.size * this.page
          ) {
            this.isBottom = true
          }
        } else {
          this.firstFetch = false
          this.$$toast({
            message: evaluatelist.message
          })
          this.hasErr = true
        }
      } catch (e) {
        this.firstFetch = false
        this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    changePage(page) {
      this.page = page
    }
  },
  components: {
    loadData,
    imagePreview,
    empty
  },
  computed: {
    ...mapState(['evaluatesList', 'previewImages'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.commment-list {
  .data-bottom {
    position: relative;
    margin: 0 auto;
    width: rem(280px);
    height: rem(70px);
    background: #f4f4f4;
    span {
      display: block;
      width: rem(280px);
      height: rem(35px);
      @include border(bottom, #c6c6c6);
    }
  }
  .data-bottom::before {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: rem(-20px) 0 0 rem(-78px);
    width: rem(156px);
    height: rem(40px);
    content: '已经到底了';
    color: #999999;
    background: #f4f4f4;
    font-size: rem(24px);
    line-height: rem(40px);
    text-align: center;
    z-index: 10;
  }
}
</style>
